export const PRIVACY_POLICY_URL = '/privacy-policy'
export const PRIVACY_CENTER_URL = '/privacy'
